import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import useApi from 'utils/hooks/api/useApi';
import { ALERT_VARIANTS, LOCALIZATION_PAGES, API_ENDPOINTS } from 'utils/constants';
import { useRoot } from 'context/RootContext';

const useScreenings = query => {
  const queryString = `${API_ENDPOINTS.SCREENINGS}?StartDate=${query.startDate}&EndDate=${query.endDate}&Term=${query.term}&VenueIds=${query.venueId}&ProgramIds=${query.programId}&LanguageId=${query.languageId}&Status=${query.status}&LowerCapacityLimit=${query.lowerCapacityLimit}&UpperCapacityLimit=${query.upperCapacityLimit}&PageSize=${query.pageSize}&Page=${query.page}&RetrieveAll=${query.retrieveAll}&IncludeCount=${query.includeCount}&SortBy=${query.sortBy}&SortOrder=${query.sortOrder}&Includes=${query.includes}`;
  const [path, setPath] = useState(queryString);
  const { t } = useTranslation(LOCALIZATION_PAGES.SCREENINGS);
  const { showNotification } = useRoot();
  const [{ result: screenings, loading, error }, getScreenings] = useApi(path, { initialFetch: false });

  useEffect(() => {
    setPath(queryString);
  }, [queryString]);

  useEffect(() => {
    if (error) {
      showNotification(
        {
          message: t('screenings_fetch_failed'),
        },
        ALERT_VARIANTS.DANGER
      );
    }
  }, [error, showNotification, t]);

  return [{ screenings, loading, error }, getScreenings];
};

export default useScreenings;
